import { render, staticRenderFns } from "./Menstruation.vue?vue&type=template&id=5c4a34da&scoped=true"
import script from "./Menstruation.vue?vue&type=script&lang=js"
export * from "./Menstruation.vue?vue&type=script&lang=js"
import style0 from "./Menstruation.vue?vue&type=style&index=0&id=5c4a34da&prod&lang=less"
import style1 from "./Menstruation.vue?vue&type=style&index=1&id=5c4a34da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a34da",
  null
  
)

export default component.exports